// LIBRARIES
import React from "react";
import ContentWithHeader from "../../../wrapper/ContentWithHeader/ContentWithHeader";

export interface ReviewListingProps {}

const ReviewListing: React.FC<ReviewListingProps> = (props) => {
    return (
        <ContentWithHeader id={"content-with-header"}>
            <p>Listing all tests to review</p>
        </ContentWithHeader>
    );
};

export default ReviewListing;
